// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Pricing Foundation Styles */

.pricing-foundation-list-card .MuiDataGrid-root {
  border: none;
}

.pricing-foundation-list-card .MuiDataGrid-cell {
  border-bottom: 1px solid #e9ecef;
}

.pricing-foundation-list-card .MuiDataGrid-columnHeaders {
  background-color: #f8f9fa;
  border-bottom: 2px solid #dee2e6;
}

.pricing-foundation-list-card .MuiDataGrid-columnHeaderTitle {
  font-weight: 600;
  color: #495057;
}

/* Form Styles */
.create-pricing-foundation-card .form-label.required::after {
  content: " *";
  color: #dc3545;
}

.create-pricing-foundation-card .form-label {
  font-weight: 500;
  color: #212529;
  margin-bottom: 0.5rem;
}

.create-pricing-foundation-card .form-control,
.create-pricing-foundation-card .form-select {
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
  padding: 0.625rem 0.75rem;
  font-size: 0.95rem;
  transition: all 0.2s ease;
}

.create-pricing-foundation-card .form-control:focus,
.create-pricing-foundation-card .form-select:focus {
  border-color: #0d6efd;
  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);
  outline: none;
}

.create-pricing-foundation-card .form-control.is-invalid,
.create-pricing-foundation-card .form-select.is-invalid {
  border-color: #dc3545;
}

.create-pricing-foundation-card .form-control.is-invalid:focus,
.create-pricing-foundation-card .form-select.is-invalid:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.create-pricing-foundation-card .invalid-feedback {
  display: block;
  color: #dc3545;
  font-size: 0.875rem;
  margin-top: 0.25rem;
}

.create-pricing-foundation-card .form-text {
  font-size: 0.875rem;
  color: #6c757d;
  margin-top: 0.25rem;
}

.create-pricing-foundation-card .form-group {
  margin-bottom: 1.5rem;
}

/* Button Styles */
.create-pricing-foundation-card .btn-primary {
  background-color: #0d6efd;
  border-color: #0d6efd;
  font-weight: 500;
  padding: 0.625rem 1.5rem;
}

.create-pricing-foundation-card .btn-primary:hover {
  background-color: #0b5ed7;
  border-color: #0a58ca;
}

.create-pricing-foundation-card .btn-primary:disabled {
  background-color: #0d6efd;
  border-color: #0d6efd;
  opacity: 0.65;
  cursor: not-allowed;
}

.create-pricing-foundation-card .btn-outline-secondary {
  color: #6c757d;
  border-color: #6c757d;
  font-weight: 500;
  padding: 0.625rem 1.5rem;
}

.create-pricing-foundation-card .btn-outline-secondary:hover {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}

.create-pricing-foundation-card .btn-outline-secondary:disabled {
  color: #6c757d;
  opacity: 0.65;
  cursor: not-allowed;
}

/* Card Styles */
.create-pricing-foundation-card.card {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  border: 1px solid #dee2e6;
}

.pricing-foundation-list-card.card {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}

.pricing-foundation-list-card .card-header {
  background-color: #f8f9fa;
}

.pricing-foundation-list-card .card-footer {
  background-color: #f8f9fa;
}

/* Input Group Styles */
.pricing-foundation-list-card .input-group-text {
  background-color: #f8f9fa;
  border-color: #dee2e6;
  color: #6c757d;
}

.pricing-foundation-list-card .input-group .form-control {
  border-color: #dee2e6;
}

.pricing-foundation-list-card .input-group .form-control:focus {
  border-color: #0d6efd;
}

/* Status Badge Styles */
.pricing-foundation-list-card .badge {
  font-size: 0.85rem;
  padding: 0.4rem 0.7rem;
  font-weight: 500;
}

.pricing-foundation-list-card .text-bg-success {
  background-color: #198754 !important;
  color: white !important;
}

.pricing-foundation-list-card .text-bg-danger {
  background-color: #dc3545 !important;
  color: white !important;
}

/* Loading State */
.pricing-foundation-list-card .text-secondary.small {
  padding: 2rem;
  text-align: center;
}

/* Filter Section */
.pricing-foundation-list-card .form-select {
  border-color: #dee2e6;
  padding: 0.5rem 0.75rem;
  font-size: 0.95rem;
}

.pricing-foundation-list-card .form-select:focus {
  border-color: #0d6efd;
  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);
}

/* Responsive adjustments */
@media (max-width: 576px) {
  .create-pricing-foundation-card .g-3 > * {
    --bs-gutter-x: 0.5rem;
    --bs-gutter-y: 0.5rem;
  }

  .create-pricing-foundation-card .row {
    --bs-gutter-x: 0.5rem;
    --bs-gutter-y: 0.5rem;
  }

  .pricing-foundation-list-card .btn-group-sm {
    display: flex;
    flex-wrap: wrap;
  }
}

/* Breadcrumb Styles */
.pricing-foundation-list-card .breadcrumb {
  background-color: transparent;
  margin-bottom: 0.5rem;
}

.pricing-foundation-list-card .breadcrumb-item {
  font-size: 0.95rem;
}

/* Menu Item Styles */
.MuiMenu-paper .MuiMenuItem-root {
  font-size: 0.95rem;
  padding: 0.5rem 1rem;
}

.MuiMenu-paper .MuiMenuItem-root i {
  font-size: 1rem;
  vertical-align: middle;
}

/* Modal Styles */
.modal-content {
  border-radius: 0.5rem;
  border: 1px solid #dee2e6;
}

.modal-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

.modal-body pre {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/sku-management/pricing-foundation/pricingFoundation.css"],"names":[],"mappings":"AAAA,8BAA8B;;AAE9B;EACE,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;EACzB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;EACrB,iDAAiD;EACjD,aAAa;AACf;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,mDAAmD;EACnD,yBAAyB;AAC3B;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA,2BAA2B;AAC3B;EACE;IACE,qBAAqB;IACrB,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;IACrB,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;AACF;;AAEA,sBAAsB;AACtB;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,uBAAuB;AACzB","sourcesContent":["/* Pricing Foundation Styles */\n\n.pricing-foundation-list-card .MuiDataGrid-root {\n  border: none;\n}\n\n.pricing-foundation-list-card .MuiDataGrid-cell {\n  border-bottom: 1px solid #e9ecef;\n}\n\n.pricing-foundation-list-card .MuiDataGrid-columnHeaders {\n  background-color: #f8f9fa;\n  border-bottom: 2px solid #dee2e6;\n}\n\n.pricing-foundation-list-card .MuiDataGrid-columnHeaderTitle {\n  font-weight: 600;\n  color: #495057;\n}\n\n/* Form Styles */\n.create-pricing-foundation-card .form-label.required::after {\n  content: \" *\";\n  color: #dc3545;\n}\n\n.create-pricing-foundation-card .form-label {\n  font-weight: 500;\n  color: #212529;\n  margin-bottom: 0.5rem;\n}\n\n.create-pricing-foundation-card .form-control,\n.create-pricing-foundation-card .form-select {\n  border: 1px solid #dee2e6;\n  border-radius: 0.375rem;\n  padding: 0.625rem 0.75rem;\n  font-size: 0.95rem;\n  transition: all 0.2s ease;\n}\n\n.create-pricing-foundation-card .form-control:focus,\n.create-pricing-foundation-card .form-select:focus {\n  border-color: #0d6efd;\n  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);\n  outline: none;\n}\n\n.create-pricing-foundation-card .form-control.is-invalid,\n.create-pricing-foundation-card .form-select.is-invalid {\n  border-color: #dc3545;\n}\n\n.create-pricing-foundation-card .form-control.is-invalid:focus,\n.create-pricing-foundation-card .form-select.is-invalid:focus {\n  border-color: #dc3545;\n  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);\n}\n\n.create-pricing-foundation-card .invalid-feedback {\n  display: block;\n  color: #dc3545;\n  font-size: 0.875rem;\n  margin-top: 0.25rem;\n}\n\n.create-pricing-foundation-card .form-text {\n  font-size: 0.875rem;\n  color: #6c757d;\n  margin-top: 0.25rem;\n}\n\n.create-pricing-foundation-card .form-group {\n  margin-bottom: 1.5rem;\n}\n\n/* Button Styles */\n.create-pricing-foundation-card .btn-primary {\n  background-color: #0d6efd;\n  border-color: #0d6efd;\n  font-weight: 500;\n  padding: 0.625rem 1.5rem;\n}\n\n.create-pricing-foundation-card .btn-primary:hover {\n  background-color: #0b5ed7;\n  border-color: #0a58ca;\n}\n\n.create-pricing-foundation-card .btn-primary:disabled {\n  background-color: #0d6efd;\n  border-color: #0d6efd;\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n.create-pricing-foundation-card .btn-outline-secondary {\n  color: #6c757d;\n  border-color: #6c757d;\n  font-weight: 500;\n  padding: 0.625rem 1.5rem;\n}\n\n.create-pricing-foundation-card .btn-outline-secondary:hover {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n\n.create-pricing-foundation-card .btn-outline-secondary:disabled {\n  color: #6c757d;\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n/* Card Styles */\n.create-pricing-foundation-card.card {\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\n  border: 1px solid #dee2e6;\n}\n\n.pricing-foundation-list-card.card {\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\n}\n\n.pricing-foundation-list-card .card-header {\n  background-color: #f8f9fa;\n}\n\n.pricing-foundation-list-card .card-footer {\n  background-color: #f8f9fa;\n}\n\n/* Input Group Styles */\n.pricing-foundation-list-card .input-group-text {\n  background-color: #f8f9fa;\n  border-color: #dee2e6;\n  color: #6c757d;\n}\n\n.pricing-foundation-list-card .input-group .form-control {\n  border-color: #dee2e6;\n}\n\n.pricing-foundation-list-card .input-group .form-control:focus {\n  border-color: #0d6efd;\n}\n\n/* Status Badge Styles */\n.pricing-foundation-list-card .badge {\n  font-size: 0.85rem;\n  padding: 0.4rem 0.7rem;\n  font-weight: 500;\n}\n\n.pricing-foundation-list-card .text-bg-success {\n  background-color: #198754 !important;\n  color: white !important;\n}\n\n.pricing-foundation-list-card .text-bg-danger {\n  background-color: #dc3545 !important;\n  color: white !important;\n}\n\n/* Loading State */\n.pricing-foundation-list-card .text-secondary.small {\n  padding: 2rem;\n  text-align: center;\n}\n\n/* Filter Section */\n.pricing-foundation-list-card .form-select {\n  border-color: #dee2e6;\n  padding: 0.5rem 0.75rem;\n  font-size: 0.95rem;\n}\n\n.pricing-foundation-list-card .form-select:focus {\n  border-color: #0d6efd;\n  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);\n}\n\n/* Responsive adjustments */\n@media (max-width: 576px) {\n  .create-pricing-foundation-card .g-3 > * {\n    --bs-gutter-x: 0.5rem;\n    --bs-gutter-y: 0.5rem;\n  }\n\n  .create-pricing-foundation-card .row {\n    --bs-gutter-x: 0.5rem;\n    --bs-gutter-y: 0.5rem;\n  }\n\n  .pricing-foundation-list-card .btn-group-sm {\n    display: flex;\n    flex-wrap: wrap;\n  }\n}\n\n/* Breadcrumb Styles */\n.pricing-foundation-list-card .breadcrumb {\n  background-color: transparent;\n  margin-bottom: 0.5rem;\n}\n\n.pricing-foundation-list-card .breadcrumb-item {\n  font-size: 0.95rem;\n}\n\n/* Menu Item Styles */\n.MuiMenu-paper .MuiMenuItem-root {\n  font-size: 0.95rem;\n  padding: 0.5rem 1rem;\n}\n\n.MuiMenu-paper .MuiMenuItem-root i {\n  font-size: 1rem;\n  vertical-align: middle;\n}\n\n/* Modal Styles */\n.modal-content {\n  border-radius: 0.5rem;\n  border: 1px solid #dee2e6;\n}\n\n.modal-header {\n  background-color: #f8f9fa;\n  border-bottom: 1px solid #dee2e6;\n}\n\n.modal-body pre {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 0.375rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
